<template>
  <div v-if="currentUserLevelBoard && currentUserLevelBoard.orgData">
    <vs-popup v-if="boardUserData" class="profile-card" :title="boardUserData &&
      boardUserData.userData &&
      boardUserData.userData.firstName
      ? `${boardUserData.userData.firstName} 's Profile Card`
      : ''
      " :active.sync="profileCardPopupActive" :button-close-hidden="true">
      <profile-card-popup :boardUserData="boardUserData" :visibilityOption="visibilityOption" />
    </vs-popup>

    <h2 style="color: #30384b" class="mb-base text-2xl md:text-3xl">
      {{ currentUserLevelBoard.title }} of
      {{ currentUserLevelBoard.orgData.name }}
    </h2>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/3" style="height: max-content">
        <user-board-step @openProfileCardPopup="profileCardPopup" :installedApps="currentUserLevelBoard.installedApps"
          :activeApp="activeApp" @setActiveApp="setActiveApp" :propOrgColor="propOrgColor" />
      </div>
      <div class="vx-col w-full md:w-3/5">
        <!-- <h4 style="color: #30384b !important" class="font-semibold my-2 md:my-0 mb-2">
          Tasks
        </h4> -->
        <user-board-step-detail :installedApps="currentUserLevelBoard.installedApps" :activeApp="activeApp" />
      </div>
    </div>
  </div>
</template>

<script>
import UserBoardStep from "../components/UserBoardStep.vue";
import UserBoardStepDetail from "../components/UserBoardStepDetail.vue";
import marketplaceList from "@/assets/data/marketplace-list.js";
import MarketplaceItem from "../components/MarketplaceItem.vue";
import ProfileCardPopup from "../components/ProfileCardPopup.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
  components: {
    MarketplaceItem,
    UserBoardStep,
    UserBoardStepDetail,
    ProfileCardPopup,
  },
  data() {
    return {
      marketplaceList,
      appDetails: {},
      userLevelBoardAnalytics: {},
      activeApp: "resume-editor",
      propOrgColor: "",
      boardUserData: {},
      profileCardPopupActive: false,
      visibilityOption: "",
    };
  },
  computed: {
    currentUserLevelBoard() {
      return this.$store.state.boards.currentUserLevelBoard;
    },
    currentBoardUserDetails() {
      return this.$store.state.boards.currentBoardUserDetails;
    },
    routeBoardId() {
      return this.$route.params.boardId;
    },
    userData() {
      return this.$store.state.users.data;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    userLevelBoards() {
      return this.$store.state.boards.userLevelBoards;
    },

  },
  watch: {
    routeBoardId(newVal) {
      this.$store
        .dispatch("boards/fetchUserLevelBoard", newVal)
        .catch((error) => {
          throw error;
        });
    },
    currentUserLevelBoard(newVal) {
      if (newVal && newVal.status && newVal.status !== "active") {
        window.location.href = "/user/dashboard";
      }
    },
    $route() {
      this.fetchUserLevelBoard();
      this.getOrgDetails();
    },
    userData() {
      this.fetchUserLevelBoard();
    },
    // userLevelBoards() {
    //   this.isCastInstalled(this.userLevelBoards);
    // },
  },
  methods: {
    getAppDetails(appId) {
      let appIndex = this.marketplaceList.findIndex((app) => appId === app.id);
      return this.marketplaceList[appIndex];
    },
    fetchUserLevelBoard() {
      this.$store
        .dispatch("boards/fetchUserLevelBoard", this.routeBoardId)
        .catch((error) => {
          throw error;
        });

      if (this.userData && this.userData._id && this.routeBoardId) {
        this.$store
          .dispatch("boards/fetchCurrentBoardUserDetails", {
            userId: this.userData._id,
            boardId: this.routeBoardId,
          })
          .then((boardUserResObj) => {
            // Verify board user status
            if (this.currentBoardUserDetails && this.currentBoardUserDetails.status !== "blocked") {
              this.$store
                .dispatch(
                  "boards/verifyBoardUserStatus",
                  this.currentBoardUserDetails._id
                )
                .catch((error) => {
                  throw error;
                });
            }
            //  else {
            //   window.location.href = "/user/dashboard";
            // }
          })
          .catch((error) => {
            throw error;
          });
      }
    },
    getOrgDetails() {
      this.$store
        .dispatch("boards/fetchBoardDetails", this.boardId)
        .then((res) => {
          this.visibilityOption = res.data.userVisibilityOption;

          this.propOrgColor = res.data.orgData.primaryThemeColor;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    setActiveApp(item) {
      this.activeApp = item;
    },
    profileCardPopup(val) {
      this.profileCardPopupActive = true;
      this.boardUserData = val;
    },
    // isCastInstalled(board) {
    //   console.log(board);
    //   if (this.userLevelBoards && this.userLevelBoards.length) {
    //     for (let i = 0; i < board.length; i++) {
    //       if (board[i].boardData.installedApps.includes("videowiki-cast")) {
    //         this.$store.commit(
    //           "videowiki/SET_CAST_INSTALLED_BOARD_NAME",
    //           board[i].boardData.title
    //         );
    //       }
    //     }
    //   }
    // },
  },
  mounted() {
    if (
      this.currentUserLevelBoard &&
      this.currentUserLevelBoard.status &&
      this.currentUserLevelBoard.status !== "active"
    ) {
      window.location.href = "/user/dashboard";
    }
  },
  created() {
    this.fetchUserLevelBoard();
  },
};
</script>

<style scoped>
/*.marketplace--item-card:hover {        
        background: #FFFDF7!important;
        border: 1px solid rgba(242, 194, 68, 0.35)!important;
        box-shadow: 0px 8px 40px rgba(242, 194, 68, 0.05);
        transition: none;
    }*/
.con-vs-popup>>>.vs-popup--background {
  background: rgba(0, 0, 0, 0.2);
}

.con-vs-popup>>>.vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
